import * as Styled from './QuantityBadge.styled';

interface QuantityBadgeProps {
  diameter: number;
  isBasket?: boolean;
  label?: string;
  quantity: number;
}

export const QuantityBadge = ({
  diameter,
  isBasket = false,
  label = 'Quantity',
  quantity,
}: QuantityBadgeProps) => (
  // #2934 A11Y-14 - Styled.Badge is a styled.span, and aria-label is prohibited on an
  // element with a generic role: most screen readers discard it, so the number was
  // announced with no context at all. Real text in the accessibility tree instead.
  <Styled.Badge $isBasket={isBasket} $diameter={diameter}>
    <span className="visually-hidden">{label}: </span>
    {quantity}
  </Styled.Badge>
);
